export default __webpack_public_path__ + "static/media/empty-variable.75d9b4cb.svg";